import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    const layoutContainer = document.getElementById('layout');

    if (layoutContainer) {
      layoutContainer.scrollIntoView();
    }
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
